import React from "react";
export function ProblemSection() {
  return <section className="bg-paper" data-id="element-116" data-mp="14h4vyrujjhsm">
      <div className="mx-auto grid max-w-6xl gap-10 px-5 py-16 md:grid-cols-2 md:gap-16 md:py-20" data-id="element-117" data-mp="2lsl8nubanf6i">
        <div className="space-y-6 text-lg leading-relaxed text-ink" data-id="element-118" data-mp="30gxw22wbfppe">
          <p className="font-display text-2xl font-bold leading-snug md:text-3xl" data-id="element-119" data-mp="30jalt28bf4d0">
            Hay momentos en los que lo que sientes está ahí…{" "}
            <span className="text-muted" data-id="element-120" data-mp="39h4cnxnb95ss">pero ponerlo en palabras no resulta tan fácil.</span>
          </p>
          <p className="text-muted" data-id="element-121" data-mp="35f95wdmm207m">
            Pensamientos que se acumulan. Emociones difíciles de ordenar. Días en los que necesitas bajar un cambio,
            despejar la cabeza o simplemente dedicarte unos minutos.
          </p>
          <p className="text-muted" data-id="element-122" data-mp="3eew4ysrvatxi">Y no siempre quieres sentarte frente a una hoja en blanco preguntándote:</p>
          <p className="border-l-4 border-sun pl-4 font-display text-2xl font-bold text-plum" data-id="element-123" data-mp="1p3vnnv4de6gb">“¿Por dónde empiezo?”</p>
        </div>

        <div className="flex flex-col gap-5 text-lg leading-relaxed text-ink md:pt-2" data-id="element-124" data-mp="jdwkyyd05oww">
          <p data-id="element-125" data-mp="obookpn0ezgx">
            Para eso creamos el <strong className="font-extrabold" data-id="element-126" data-mp="oczsqqkda98k">MegaPack Arteterapia +50 Técnicas</strong> de
            RecursoPDF.
          </p>
          <p className="text-muted" data-id="element-127" data-mp="sbp2m96758ng">
            Una colección digital de ejercicios creativos guiados que utiliza el dibujo, la escritura, los colores, las
            formas y diferentes recursos visuales como herramientas de autoexploración y bienestar emocional.
          </p>
          <ul className="space-y-1 border-y border-line py-5 font-bold" data-id="element-128" data-mp="1714tdp5q9e35">
            <li data-id="element-129" data-mp="1c2u391h7rlpn">No necesitas saber dibujar.</li>
            <li data-id="element-130" data-mp="1bzy63fd6x129">No necesitas ser una persona especialmente creativa.</li>
            <li data-id="element-131" data-mp="1g2uj8qjyo4yt">Y tampoco necesitas experiencia previa.</li>
          </ul>
          <p className="font-display text-xl font-bold text-plum" data-id="element-132" data-mp="3du77dobcxpkn">
            Solo elegir una actividad, seguir las instrucciones y comenzar.
          </p>
        </div>
      </div>
    </section>;
}